"use client";

import { CalendarIcon } from "@/components/appIcons";

import { FilterChip, formatYearRangeLabel } from "./filter-chip";

export function SearchYearFilterChip({
  yearFrom,
  yearTo,
  clear,
}: {
  yearFrom: number | undefined;
  yearTo: number | undefined;
  clear: () => void;
}) {
  if (!yearFrom && !yearTo) return null;
  return (
    <FilterChip icon={CalendarIcon} onClear={clear}>
      {formatYearRangeLabel(yearFrom, yearTo)}
    </FilterChip>
  );
}
